import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  name: 'Stefan K.',
  city: 'Zürich',
  role: 'Berufsbildner Automatik EFZ · 32 Jahre',
  text: 'Als neuer Berufsbildner war dieses System meine Rettung. Kein Rätselraten mehr bei der Semesterplanung. In der ersten Woche habe ich 10 Stunden gespart. Die Ladder-Vorlagen sind genau das, was ich brauchte.'
}, {
  name: 'Claudia M.',
  city: 'Basel',
  role: 'Elektrotechnik Lehrperson · 47 Jahre',
  text: 'Endlich Schweizer Industriefälle, die meine Lernenden wirklich motivieren. Das SPS-Modul ist das Beste, was ich je in einem Fachlehrwerk gesehen habe. Deutlich besser strukturiert als alles von Festo oder Siemens.'
}, {
  name: 'Patrick B.',
  city: 'Bern',
  role: 'Berufsschule Maschinentechnik · 41 Jahre',
  text: 'Herunterladen, ausdrucken, unterrichten. Mehr braucht es nicht. Die Zeitersparnis ist enorm. Meine Wochenenden gehören wieder mir und meinen Lernenden gefallen die realen Industrieprojekte.'
}, {
  name: 'Andreas H.',
  city: 'Luzern',
  role: 'Instruktor Automation · 38 Jahre',
  text: 'Das HMI/SCADA-Modul deckt genau die Lücke, die ich in meinen Lektionen hatte. Die Pneumatik-Übungen sind so praxisnah, dass meine Lernenden nach jeder Stunde mehr verstehen.'
}, {
  name: 'Daniel W.',
  city: 'St. Gallen',
  role: 'Berufsfachschule Elektroniker · 52 Jahre',
  text: 'In 22 Jahren Lehrtätigkeit habe ich noch nie ein so komplettes Paket gesehen. Die Schaltplan-Bibliothek allein ist den Preis dreifach wert. Industrie 4.0 endlich richtig vermittelt.'
}];
export function Testimonials() {
  return <section className="py-10 px-4 bg-brand-card-bg border-y border-gray-200" data-id="element-189">
      <div className="max-w-2xl mx-auto" data-id="element-190">
        <h2 className="text-2xl sm:text-3xl font-black text-center text-brand-charcoal mb-6" data-id="element-191">
          Was Schweizer Instruktoren sagen
        </h2>
        <div className="space-y-3 sm:space-y-4" data-id="element-192">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.06
        }} className="bg-white border border-gray-200 p-4 sm:p-5 rounded-xl shadow-sm" data-id="element-193">
              <div className="flex text-brand-gold mb-2" data-id="element-194">
                {[...Array(5)].map((_, idx) => <StarIcon key={idx} className="w-4 h-4 fill-current" data-id="element-195" />)}
              </div>
              <p className="text-gray-700 font-medium italic mb-3 text-[14px] sm:text-base leading-relaxed" data-id="element-196">
                "{t.text}"
              </p>
              <div className="border-t border-gray-100 pt-2.5" data-id="element-197">
                <div className="font-bold text-brand-charcoal text-[13px] sm:text-sm" data-id="element-198">
                  {t.name} · {t.city}
                </div>
                <div className="text-[11px] sm:text-xs text-gray-500" data-id="element-199">
                  {t.role}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}